import React, { useEffect, useRef, useState } from "react";
import { Dimmer } from "./spinner";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  validaNumeroTelefono,
  validaEmail,
  diasMes,
  cmes,
} from "../util/varios";
import { Mensaje, MensajeSiNo } from "./mensajes";
import axios from "axios";

export const ResumenCaja = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  const op = require("../../public/modulos/datos");
  const fechaTope = moment(
    JSON.parse(localStorage.getItem("fechasistema"))
  ).format("YYYY-MM-DD");
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFechaDesde = useRef();
  const txtFechaHasta = useRef();
  const cmbMensual = useRef();
  const cmbMesTrimes = useRef();
  const cmbCaja1 = useRef();
  const cmbCaja2 = useRef();
  const radioHoy = useRef();
  const radioFecha = useRef();
  const radioMensual = useRef();
  const radioTrimestral = useRef();
  const radioAnual = useRef();
  const radioTodas = useRef();
  const radioDesde = useRef();
  const cmbImpuesto  = useRef();

  const [impuesto, setImpuesto] = useState()
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [disabledCaja, setDisabledCaja] = useState(false);
  const [visible, setVisible] = useState({
    porfecha: "collapse",
    mensual: "collapse",
    trimestral: "collapse",
    caja: "collapse",
  });

  const onChange = (event) => {
    if (event.target.name === "rango") {
      if (event.target.value === "1") {
        setVisible({
          ...visible,
          porfecha: "collapse",
          mensual: "collapse",
          trimestral: "collapse",
        });
        setDisabledCaja(false);
        txtFechaDesde.current.value = fechaTope;
        txtFechaHasta.current.value = fechaTope;
      }

      if (event.target.value === "2") {
        setVisible({
          ...visible,
          porfecha: "visible",
          mensual: "collapse",
          trimestral: "collapse",
        });
        setDisabledCaja(false);
      }

      if (event.target.value === "3") {
        setVisible({
          ...visible,
          porfecha: "collapse",
          mensual: "visible",
          trimestral: "collapse",
          caja: "collapse",
        });
        setDisabledCaja(true);
        radioTodas.current.checked = true;
        radioDesde.current.checked = false;
        cmbCaja1.current.value = "01";
        cmbCaja2.current.value = "10";
      }

      if (event.target.value === "4") {
        setVisible({
          ...visible,
          porfecha: "collapse",
          mensual: "collapse",
          trimestral: "visible",
          caja: "collapse",
        });
        setDisabledCaja(true);
        radioTodas.current.checked = true;
        radioDesde.current.checked = false;
        cmbCaja1.current.value = "01";
        cmbCaja2.current.value = "10";
      }

      if (event.target.value === "5") {
        setVisible({
          ...visible,
          porfecha: "collapse",
          mensual: "collapse",
          trimestral: "collapse",
          caja: "collapse",
        });
        setDisabledCaja(true);
        radioTodas.current.checked = true;
        radioDesde.current.checked = false;
        cmbCaja1.current.value = "01";
        cmbCaja2.current.value = "10";
      }
    }

    if (event.target.name === "caja") {
      if (event.target.value === "1") {
        setVisible({
          ...visible,
          caja: "collapse",
        });
        cmbCaja1.current.value = "01";
        cmbCaja2.current.value = "10";
      }

      if (event.target.value === "2") {
        setVisible({
          ...visible,
          caja: "visible",
        });
        cmbCaja1.current.value = "01";
        cmbCaja2.current.value = "10";
      }
    }

    if (event.target.name === "caja1") {
      if (parseInt(event.target.value) > parseInt(cmbCaja2.current.value)) {
        event.target.value = "01";
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "la seleccion no debe ser mayor a la primera",
          icono: "informacion",
        });
      }
    }

    if (event.target.name === "caja2") {
      if (parseInt(event.target.value) < parseInt(cmbCaja1.current.value)) {
        event.target.value = "10";
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "la seleccion no debe ser menor a la primera",
          icono: "informacion",
        });
      }
    }

    if (event.target.name === "fechadesde") {
      let first = new Date(event.target.value);
      let second = new Date(txtFechaHasta.current.value);

      if (first > second) {
        event.target.value = txtFechaHasta.current.value;
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "la fecha desde no debe ser mayor a la de hasta",
          icono: "informacion",
        });
      }
    }

    if (event.target.name === "fechahasta") {
      let first = new Date(txtFechaDesde.current.value);
      let second = new Date(event.target.value);

      if (first > second) {
        event.target.value = txtFechaDesde.current.value;
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "la fecha hasta no debe ser menor a la de desde",
          icono: "informacion",
        });
      }
    }
  };

  const blanquear = () => {
    setActivate(false);
    setVisible({
      porfecha: "collapse",
      mensual: "collapse",
      trimestral: "collapse",
      caja: "collapse",
    });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const cerrarModal = () => {
    if (mensaje.titulo === "Exito.") {
      props.onHideRenderizar();
      props.onHideCancela();
      blanquear();
    }

    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const imprimirReporte = () => {
    if (props.reporte === "resumenCaja") {
      if (
        props.reporte === "resumenCaja" &&
        (radioAnual.current.checked ||
          radioTrimestral.current.checked ||
          radioMensual.current.checked)
      ) {
        let fileName = "";
        let fileNamePdf = "";

        if (radioMensual.current.checked) {
          fileName = "Tes_CajIngresoMes";
          let MESDESCRIP = cmes(parseInt(cmbMensual.current.value));
          let DIA = diasMes(parseInt(cmbMensual.current.value), anioActu);
          let MES = cmbMensual.current.value;
          let ANIO = anioActu.toString();
          let CONDICION = "TRUE";

          window.open(
            `${op.reportes}reporte=${fileName}&CONDICION=${CONDICION}&MESDESCRIP=${MESDESCRIP}&DIA=${DIA}&MES=${MES}&ANIO=${ANIO}`,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
          );
        } else if (radioTrimestral.current.checked) {
          if (cmbMesTrimes.current.value === "01") {
            fileName = "Tes_CajIngresoTrimes1";
          } else if (cmbMesTrimes.current.value === "02") {
            fileName = "Tes_CajIngresoTrimes2";
          } else if (cmbMesTrimes.current.value === "03") {
            fileName = "Tes_CajIngresoTrimes3";
          } else if (cmbMesTrimes.current.value === "04") {
            fileName = "Tes_CajIngresoTrimes4";
          }

          let ANIO = anioActu.toString();
          let CONDICION = "TRUE";

          window.open(
            `${op.reportes}reporte=${fileName}&CONDICION=${CONDICION}&ANIO=${ANIO}`,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
          );
        } else if (radioAnual.current.checked) {
          fileName = "Tes_CajIngresoTrimesAnio";
          let ANIO = anioActu.toString();
          let CONDICION = "TRUE";

          window.open(
            `${op.reportes}reporte=${fileName}&CONDICION=${CONDICION}&ANIO=${ANIO}`,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
          );
        }

        fileNamePdf = "Tes_CajIngreso2.pdf";
      } else {
        let val2 = moment(txtFechaDesde.current.value).format("DD-MM-YYYY");
        let val3 = moment(txtFechaHasta.current.value).format("DD-MM-YYYY");
        let val4 = cmbCaja1.current.value;
        let val5 = cmbCaja2.current.value;
        let sql = "";
        let sql2 = "";
        let sql3 = "";

        if (radioHoy.current.checked) {
          sql2 = `Resumen del Día ${val2}`;
        } else {
          if (val4 === val5) {
            sql3 = `  ${val4}`;
          } else {
            sql3 = `${val4} a la ${val5}`;
          }
          if (val2 === val3) {
            sql2 = `Resumen del Día ${val2}`;
          } else {
            sql2 = `DESDE EL ${val2} HASTA EL ${val3}`;
          }
        }

        if (radioDesde.current.checked) {
          sql = `NumCaja Between '${val4}' and '${val5}'`;
        } else {
          sql = "true";
        }

        let fileName = "Tes_CajIngreso";
        let fileNamePdf = "Resumen_de_Caja.pdf";

        let reporte = props.reporte;
        let CONDICION = sql.trim();
        let TIT_RGO1 = sql2.trim();
        let TIT_CRI1 = sql3.trim();
        let INIFECHA = `'${val2}'`;
        let FINFECHA = `'${val3}'`;

        window.open(
          `${op.reportes}reporte=${fileName}&CONDICION=${CONDICION}&TIT_RGO1=${TIT_RGO1}&INIFECHA=${INIFECHA}&FINFECHA=${FINFECHA}&TIT_CRI1=${TIT_CRI1}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      }
    } else if (props.reporte === "resumenCajaBanco") {
      let val2 = moment(txtFechaDesde.current.value).format("DD-MM-YYYY");
      let val3 = moment(txtFechaHasta.current.value).format("DD-MM-YYYY");
      let val4 = cmbCaja1.current.value;
      let val5 = cmbCaja2.current.value;
      let sql = "";
      let sql2 = "";
      let sql3 = "";

      if (radioHoy.current.checked) {
        sql2 = `Resumen del Día ${val2}`;
      } else {
        if (val4 === val5) {
          sql3 = `  ${val4}`;
        } else {
          sql3 = `${val4} a la ${val5}`;
        }
        if (val2 === val3) {
          sql2 = `Resumen del Día ${val2}`;
        } else {
          sql2 = `DESDE EL ${val2} HASTA EL ${val3}`;
        }
      }

      if (radioDesde.current.checked) {
        sql = ` TRANS.NumCaja   Between '${val4}' and '${val5}'`;
      } else {
        sql = "true";
      }

      let fileName = "Tes_CajIngresoBanco";
      let fileNamePdf = "Resumen_de_Caja_Bancos.pdf";

      let CONDICION = sql.trim();
      let TIT_RGO1 = sql2.trim();
      let TIT_CRI1 = sql3.trim();
      let INIFECHA = `'${val2}'`;
      let FINFECHA = `'${val3}'`;

      window.open(
        `${op.reportes}reporte=${fileName}&CONDICION=${CONDICION}&TIT_RGO1=${TIT_RGO1}&INIFECHA=${INIFECHA}&FINFECHA=${FINFECHA}&TIT_CRI1=${TIT_CRI1}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else if (props.reporte === "resumenTransaccionesReversadas") {
      let val2 = moment(txtFechaDesde.current.value).format("DD-MM-YYYY");
      let val3 = moment(txtFechaHasta.current.value).format("DD-MM-YYYY");
      let val4 = cmbCaja1.current.value;
      let val5 = cmbCaja2.current.value;
      let sql;
      let sql2 = null;
      let sql3 = null;

      if (radioHoy.current.checked) {
        sql = `fechareverso Between '${val2}' AND '${val3}' AND NumCaja Between '01' and '10'`;
        sql2 = `Transacciones del Día ${val2}`;
        sql3 = `Transacciones Reversadas `;
      } else {
        sql = `fechareverso Between '${val2}' AND '${val3}' AND NumCaja Between '${val4}' and '${val5}'`;
        sql2 = `DESDE EL ${val2} HASTA EL ${val3}`;
        sql3 = `Transacciones Reversadas `;
      }
      let fileName = "Tes_CajIngresoTr";
      let fileNamePdf = "Resumen_de_Transacciones_Reversadas.pdf";

      let CONDICION = sql.trim();
      let TIT_RGO1 = sql2.trim();
      let TIT_CRI1 = sql3;
      let FINFECHA = `'${val3}'`;
      let REVERSADO = `1`;

      window.open(
        `${op.reportes}reporte=${fileName}&CONDICION=${CONDICION}&TIT_RGO1=${TIT_RGO1}&REVERSADO=${REVERSADO}&FINFECHA=${FINFECHA}&TIT_CRI1=${TIT_CRI1}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else if (props.reporte === "resumenTransacciones") {
      let val2 = moment(txtFechaDesde.current.value).format("DD-MM-YYYY");
      let val3 = moment(txtFechaHasta.current.value).format("DD-MM-YYYY");
      let val4 = cmbCaja1.current.value;
      let val5 = cmbCaja2.current.value;
      let sql;
      let sql2 = null;
      let sql3 = null;

      if (radioHoy.current.checked) {
        sql = `fechaPago Between '${val2}' AND '${val3}' AND NumCaja Between '01' and '10'`;
        sql2 = `Transacciones del Día ${val2}`;
        sql3 = `Transacciones Diarias `;
      } else {
        sql = `fechaPago Between '${val2}' AND '${val3}' AND NumCaja Between '${val4}' and '${val5}'`;
        sql2 = `DESDE EL ${val2} HASTA EL ${val3}`;
        sql3 = `Transacciones Diarias`;
      }
      let fileName = "Tes_CajIngresoTr";
      let fileNamePdf = "Resumen_de_Transacciones.pdf";

      let CONDICION = sql.trim();
      let TIT_RGO1 = sql2.trim();
      let TIT_CRI1 = sql3;
      let FINFECHA = `'${val3}'`;
      let REVERSADO = `0`;

      let tipoi = cmbImpuesto.current.value.toString() === '0' ? 'AND MOVC.IdTipoingreso > 0' : 'AND MOVC.IdTipoingreso ='+ cmbImpuesto.current.value
     
      window.open(
        `${op.reportes}reporte=${fileName}&CONDICION=${CONDICION}&TIT_RGO1=${TIT_RGO1}&REVERSADO=${REVERSADO}&FINFECHA=${FINFECHA}&TIT_CRI1=${TIT_CRI1}&TIPO=${tipoi}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else if (props.reporte === "resumenTransaccionesDetalladas") {
      let val2 = moment(txtFechaDesde.current.value).format("DD-MM-YYYY");
      let val3 = moment(txtFechaHasta.current.value).format("DD-MM-YYYY");
      let val4 = cmbCaja1.current.value;
      let val5 = cmbCaja2.current.value;
      let sql;
      let sql2 = null;
      let sql3 = null;

      if (radioHoy.current.checked) {
        sql = `FechaPago Between '${val2}' AND '${val3}' AND TRAN.NumCaja Between '01'and '10'`;
        sql2 = `Transacciones del Día ${val2}`;
        sql3 = `Todas las Cajas`;
      } else {
        sql = `FechaPago Between '${val2}' AND '${val3}' AND TRAN.NumCaja Between '${val4}' and '${val5}'`;
        sql2 = `DESDE EL ${val2} HASTA EL ${val3}`;
        sql3 = `Desde la Caja ${val4.trim()} Hasta la ${val5.trim()}`;
      }
      let fileName = "Tes_CajIngresoPagoSatebco";
      let fileNamePdf = "Resumen_de_Transacciones_Detalladas.pdf";

      let CONDICION = sql.trim();
      let TIT_RGO1 = sql2.trim();
      let TIT_CRI1 = sql3;
      let FINFECHA = `'${val3}'`;
      let REVERSADO = `0`;
      let CAJA =
        radioDesde.current.checked && val4.trim() === val5.trim() ? "1" : "0";

      window.open(
        `${op.reportes}reporte=${fileName}&CONDICION=${CONDICION}&TIT_RGO1=${TIT_RGO1}&REVERSADO=${REVERSADO}&CAJA=${CAJA}&FINFECHA=${FINFECHA}&TIT_CRI1=${TIT_CRI1}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };

  const seleccionarImpuestos = () => {

    let campos = "*";
    let nomtab = "tipoimpuesto";
    let condi = "idtipoimpuesto > 0";
    let orden = "idtipoimpuesto ASC";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          app: "admin"
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setImpuesto(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);

        //setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarImpuestos();
  }, []);


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => { }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>{props.titulo}</Modal.Title>
        <button
          ref={btnCancela}
          style={{
            border: 0,
            margin: 0,
            padding: 0,
            color: "#ffffff",
            backgroundColor: "transparent",
          }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <div>
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <fieldset className=" row col-sm-12 mx-auto border rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px", fontWeight: "bold" }}
              >
                Rango de Fecha
              </legend>

              <div className="row col-md-6">
                <div className="col-md-4 d-flex">
                  <input
                    ref={radioHoy}
                    style={{
                      width: "1.25rem",
                      height: "1.25rem",
                      outline: "none",
                    }}
                    onChange={onChange}
                    value="1"
                    defaultChecked={true}
                    type="radio"
                    id="rango"
                    name="rango"
                  />
                  <label
                    className="form-check-label  px-1"
                    htmlFor="exonintereses"
                  >
                    Hoy
                  </label>
                </div>
                <div className="col-md-4 d-flex">
                  <input
                    ref={radioFecha}
                    style={{
                      width: "1.25rem",
                      height: "1.25rem",
                      outline: "none",
                    }}
                    onChange={onChange}
                    value="2"
                    type="radio"
                    id="rango"
                    name="rango"
                  />
                  <label className="form-check-label px-1" htmlFor="exonmultas">
                    Por Fecha
                  </label>
                </div>
              </div>

              <div
                className="row col-md-6"
                style={{ visibility: visible.porfecha }}
              >
                <div className="input-group input-group-sm col-sm-6">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Desde:
                  </label>
                  <input
                    type="date"
                    name="fechadesde"
                    onChange={onChange}
                    ref={txtFechaDesde}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    max={fechaTope}
                    defaultValue={fechaTope}
                  />
                </div>
                <div className="input-group input-group-sm col-sm-6">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Hasta:
                  </label>
                  <input
                    type="date"
                    name="fechahasta"
                    onChange={onChange}
                    ref={txtFechaHasta}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    max={fechaTope}
                    defaultValue={fechaTope}
                  />
                </div>
              </div>

              {props.reporte === "resumenCaja" && (
                <div className="row col-md-6">
                  <div className="col-md-4 d-flex">
                    <input
                      ref={radioMensual}
                      style={{
                        width: "1.25rem",
                        height: "1.25rem",
                        outline: "none",
                      }}
                      onChange={onChange}
                      value="3"
                      type="radio"
                      id="rango"
                      name="rango"
                    />
                    <label className="form-check-label px-1" htmlFor="rango">
                      Mensual
                    </label>
                  </div>
                  <div className="col-md-4 d-flex">
                    <input
                      ref={radioTrimestral}
                      style={{
                        width: "1.25rem",
                        height: "1.25rem",
                        outline: "none",
                      }}
                      onChange={onChange}
                      value="4"
                      type="radio"
                      id="rango"
                      name="rango"
                    />
                    <label className="form-check-label px-1" htmlFor="rango">
                      Trimestral
                    </label>
                  </div>
                  <div className="col-md-4 d-flex">
                    <input
                      ref={radioAnual}
                      style={{
                        width: "1.25rem",
                        height: "1.25rem",
                        outline: "none",
                      }}
                      onChange={onChange}
                      value="5"
                      type="radio"
                      id="rango"
                      name="rango"
                    />
                    <label className="form-check-label px-1" htmlFor="rango">
                      Anual
                    </label>
                  </div>
                </div>
              )}

              {visible.mensual === "visible" && (
                <select
                  ref={cmbMensual}
                  className="form-select form-select-sm col-md-6"
                >
                  <option key="01" value="01">
                    ENERO
                  </option>
                  <option key="02" value="02">
                    FEBRERO
                  </option>
                  <option key="03" value="03">
                    MARZO
                  </option>
                  <option key="04" value="04">
                    ABRIL
                  </option>
                  <option key="05" value="05">
                    MAYO
                  </option>
                  <option key="06" value="06">
                    JUNIO
                  </option>
                  <option key="07" value="07">
                    JULIO
                  </option>
                  <option key="08" value="08">
                    AGOSTO
                  </option>
                  <option key="09" value="09">
                    SEPTIEMBRE
                  </option>
                  <option key="10" value="10">
                    OCTUBRE
                  </option>
                  <option key="11" value="11">
                    NOVIEMBRE
                  </option>
                  <option key="12" value="12">
                    DICIEMBRE
                  </option>
                </select>
              )}

              {visible.trimestral === "visible" && (
                <select
                  ref={cmbMesTrimes}
                  className="form-select form-select-sm col-md-6"
                >
                  <option key="01" value="01">
                    1ER TRIMESTRE
                  </option>
                  <option key="02" value="02">
                    2DO TRIMESTRE
                  </option>
                  <option key="03" value="03">
                    3RO TRIMESTRE
                  </option>
                  <option key="04" value="04">
                    4TO TRIMESTRE
                  </option>
                </select>
              )}
            </fieldset>

            <fieldset className=" row col-sm-12 mx-auto border rounded">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px", fontWeight: "bold" }}
              >
                Numero de Caja
              </legend>
              <div className="row col-md-3">
                <div className="col-md-6 d-flex">
                  <input
                    ref={radioTodas}
                    disabled={disabledCaja}
                    style={{
                      width: "1.25rem",
                      height: "1.25rem",
                      outline: "none",
                    }}
                    onChange={onChange}
                    defaultChecked={true}
                    value="1"
                    type="radio"
                    id="caja"
                    name="caja"
                  />
                  <label className="form-check-label px-1" htmlFor="caja">
                    Todas
                  </label>
                </div>
                <div className="col-md-6 d-flex">
                  <input
                    ref={radioDesde}
                    disabled={disabledCaja}
                    style={{
                      width: "1.25rem",
                      height: "1.25rem",
                      outline: "none",
                    }}
                    onChange={onChange}
                    value="2"
                    type="radio"
                    id="caja"
                    name="caja"
                  />
                  <label className="form-check-label px-1" htmlFor="caja">
                    Desde
                  </label>
                </div>
              </div>

              <div
                className="row col-md-6"
                style={{ visibility: visible.caja }}
              >
                <div className="input-group input-group-sm col-md-6">
                  <label className="input-group-text">Caja N</label>
                  <select
                    ref={cmbCaja1}
                    name="caja1"
                    onChange={onChange}
                    disabled={disabledCaja}
                    defaultValue="01"
                    className="form-select form-select-sm"
                  >
                    <option key="01" value="01">
                      01
                    </option>
                    <option key="02" value="02">
                      02
                    </option>
                    <option key="03" value="03">
                      03
                    </option>
                    <option key="04" value="04">
                      04
                    </option>
                    <option key="05" value="05">
                      05
                    </option>
                    <option key="06" value="06">
                      06
                    </option>
                    <option key="07" value="07">
                      07
                    </option>
                    <option key="08" value="08">
                      08
                    </option>
                    <option key="09" value="09">
                      09
                    </option>
                    <option key="10" value="10">
                      10
                    </option>
                  </select>
                </div>
                <div className="input-group input-group-sm col-md-6">
                  <label className="input-group-text">Caja N</label>
                  <select
                    ref={cmbCaja2}
                    name="caja2"
                    onChange={onChange}
                    disabled={disabledCaja}
                    defaultValue="10"
                    className="form-select form-select-sm"
                  >
                    <option key="01" value="01">
                      01
                    </option>
                    <option key="02" value="02">
                      02
                    </option>
                    <option key="03" value="03">
                      03
                    </option>
                    <option key="04" value="04">
                      04
                    </option>
                    <option key="05" value="05">
                      05
                    </option>
                    <option key="06" value="06">
                      06
                    </option>
                    <option key="07" value="07">
                      07
                    </option>
                    <option key="08" value="08">
                      08
                    </option>
                    <option key="09" value="09">
                      09
                    </option>
                    <option key="10" value="10">
                      10
                    </option>
                  </select>
                </div>

             
              </div>
              {props.reporte === "resumenTransacciones" ? <div class="input-group input-group-sm mt-3 mb-3">
                  <span class="input-group-text" id="inputGroup-sizing-sm">Tipo de Impuesto</span>
                  <select ref={cmbImpuesto} class="form-select" aria-label="Default select example">

                    <option value="0">Todo</option>

                    {impuesto &&
                      impuesto.map((item, index) => (
                        <option key={index} value={item.idtipoingreso}>
                          {item.descripcion.toUpperCase()}
                        </option>
                      ))}

                  </select>
                </div> : ''}
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={imprimirReporte}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Mensaje mensaje={mensaje} onHide={cerrarModal} />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modalResumenCaja.js